const onRun = () => {
    // HP - Top products
    const gtmItems = Array.from(document.querySelectorAll('[data-gtm-item]'));

    gtmItems.forEach(item => {
        item.addEventListener('click', (e) => {
            try {
                const itemData = JSON.parse(item.getAttribute('data-gtm-item'));

                dataLayer.push({
                    'event': 'select_item',
                    'ecommerce': {
                        "items": [
                            itemData
                        ]
                    },
                });
            } catch (e) {
                console.error(e);
            }
        });
    });

};
if (document.readyState !== 'loading') {
    onRun();
} else {
    document.addEventListener('DOMContentLoaded', function () {
        onRun()
    });
}

